import { render, staticRenderFns } from "./RoleAdd.vue?vue&type=template&id=6ee6e6d4&scoped=true"
import script from "./RoleAdd.vue?vue&type=script&lang=js"
export * from "./RoleAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee6e6d4",
  null
  
)

export default component.exports